export default __webpack_public_path__ + "static/media/trylleby-property-17.16ab1b11.jpg";